// menu.jsx


import React, { useState, useEffect } from 'react';
import LogoAgendex from '../../Assets/agendex/iconLogoAgendex.png';

const activeLink = "nav-link active btn btn-outline-success me-4";
const inactiveLink = "nav-link";

function Menu({ activeSection }) {
    const [paginaAtiva, setPaginaAtiva] = useState('home');

    useEffect(() => {
        setPaginaAtiva(activeSection);
    }, [activeSection]);

    const handlePaginaAtiva = (pagina) => {
        setPaginaAtiva(pagina);
        document.getElementById('navbarSupportedContent').classList.remove('show');
    };



    return (
        <nav className="navbar fixed-top navbar-expand-lg bg-body-tertiary">
            <div className="container-fluid justify-content-start">
                <a className="navbar-brand" href="/">
                    <img src={LogoAgendex} height="28" alt="Agendex" />
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <a className={paginaAtiva === 'home' ? activeLink : inactiveLink} aria-current="page" href="#banner" onClick={() => handlePaginaAtiva('home')}>
                                Home
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className={paginaAtiva === 'vantagens' ? activeLink : inactiveLink} href="#features" onClick={() => handlePaginaAtiva('vantagens')}>
                                Vantagens
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className={paginaAtiva === 'categorias' ? activeLink : inactiveLink} href="#categorias" onClick={() => handlePaginaAtiva('categorias')}>
                                Categorias
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className={paginaAtiva === 'fotos' ? activeLink : inactiveLink} href="#fotos" onClick={() => handlePaginaAtiva('fotos')}>
                                Agilidade
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className={paginaAtiva === 'precos' ? activeLink : inactiveLink} href="#preco" onClick={() => handlePaginaAtiva('precos')}>
                                Planos e Preços
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className={paginaAtiva === 'contato' ? activeLink : inactiveLink} href="#footer" onClick={() => handlePaginaAtiva('contato')}>
                                Contato
                            </a>
                        </li>
                    </ul>
                    {/* Botão "Entrar" alinhado à direita */}
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <a className="nav-link" href="/app/login">
                                <i className="bi bi-box-arrow-in-right me-1"></i> Entrar
                            </a>
                        </li>
                    </ul>
                    
                    {/* // Dentro do <ul className="navbar-nav ..."> */}
                    {/* <li className="nav-item ms-auto">
                        <a className="nav-link" href="/app/login">
                            <i className="bi bi-box-arrow-in-right me-1"></i> Entrar
                        </a>
                    </li> */}
                </div>
            </div>
        </nav>
    );
}

export default Menu;